var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilV2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42755 16.9929V13.5539L13.1087 2.89301C13.2705 2.74466 13.4494 2.63003 13.6452 2.54911C13.841 2.46819 14.0465 2.42773 14.2618 2.42773C14.477 2.42773 14.686 2.46819 14.8889 2.54911C15.0917 2.63003 15.267 2.75141 15.4148 2.91324L16.5275 4.04609C16.6893 4.19444 16.8074 4.36976 16.8819 4.57205C16.9563 4.77435 16.9933 4.97664 16.9927 5.17894C16.9927 5.39472 16.9558 5.60052 16.8819 5.79634C16.808 5.99216 16.6898 6.17072 16.5275 6.33201L5.86655 16.9929H2.42755ZM14.2415 6.31178L15.3744 5.17894L14.2415 4.04609L13.1087 5.17894L14.2415 6.31178Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilV2Icon);
export default __webpack_public_path__ + "static/media/pencil-v2-icon.8b89c393ef8c449063fe3d8067d34be5.svg";
export { ForwardRef as ReactComponent };